<div
  class="ddc-read-note-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with note title and privacy -->
  <div class="sheet-header">
    <div class="header-left">
      <ddc-text-gradient class="text-xl" [_icon]="'text_snippet'" [_text]="'Note'" [_type]="'1'"></ddc-text-gradient>

      <div class="content-row dictionaries" *ngIf="note()?.dictionaries?.length">
        <ddc-dic-s
          class="dictionary-item"
          *ngFor="let dic of note()?.dictionaries | slice: 0 : 3"
          [label]="dic.title"
        ></ddc-dic-s>
      </div>
      <ddc-privacy [code]="note()?.privacy" [withText]="false"></ddc-privacy>
      <!-- Dictionaries row -->
    </div>
  </div>

  <mat-divider></mat-divider>

  <!-- Content section -->
  <div class="sheet-content">
    <!-- Note details row -->
    <ddc-profile-pic
      [dynamicRoute]="'/users/' + note()?.owner?.username"
      [followerCount]="note()?.owner?.followers_count"
      [minimal]="true"
      [subscription]="note()?.owner?.subscription"
      [username]="note()?.owner?.username"
      [userProfilePic]="note()?.owner?.profile_pic"
      (click)="onProfilePicClick()"
    ></ddc-profile-pic>

    <div class="content-row note-details">
      <span class="note-text">{{ note()?.title }}</span>
    </div>

    <!-- Text section -->
    <div class="content-row" *ngIf="note()?.text">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <span>Text</span>
      </div>
      <div class="section-content markdown-body">
        <markdown [data]="note()?.text"></markdown>
      </div>
    </div>
  </div>
</div>
